import gql from "graphql-tag";

export const rotaryFragment = gql`
  fragment RotaryFragment on Rotary {
    id
    theme
    number
    isEnable
    createDate
    startDate
    endDate
    rotaryType
    languageCode
    isAffUse
  }
`;

export const rotaryDetailsFragment = gql`
  ${rotaryFragment}
  fragment RotaryDetailsFragment on Rotary {
    ...RotaryFragment
    titleText
    subtitleText
    citationText
    rulesText
    titleImage
    titleImageMb
    subtitleImage
    subtitleImageMb
    backgroundImage
    backgroundImageMb
    subjectImage
    subjectImageMb
    voucherImage
    voucherImageMb
    voucherTextColor
    backgroundFromColor
    backgroundToColor
    buttomFromColor
    buttomToColor
    buttomTextColor
    subjectTextColor
    buttomFrameColor
    rotaryTextColor
    inputFrameColor
    coreImage
    coreImageMb
    tasselsImage
    tasselsImageMb
    thumbnailPc
    thumbnailMb
    limitImage
    limitImageMb
    endImage
    endImageMb
    items {
      id
      text
      probability
      voucher {
        id
        name
        code
      }
    }
  }
`;
